import { supabase } from '@/lib/supabase';

export type UnifiedProjectMemberSearchRow = {
  entity_type: 'member' | 'invite' | 'org_member';
  id: string;
  name: string;
  email: string;
  role: string;
  member_since: string | null;
  org_member: any | null;
  project_member: any | null;
  invitation: any | null;
  invitation_status: string | null;
};

export const searchProjectMemberManagement = async ({
  projectId,
  query,
}: {
  projectId: string;
  query?: string;
}): Promise<UnifiedProjectMemberSearchRow[]> => {
  const { data, error } = await supabase.rpc(
    'search_project_member_management',
    {
      p_project_id: Number(projectId),
      p_query: query ?? undefined,
    },
  );
  if (error) throw error;
  return (data || []) as UnifiedProjectMemberSearchRow[];
};
